import { default as utils } from "../utils.min.js";

function switchContent($navItem, selectedTab) {
	const $solutionTabs = $(".js-ft-product .solution-lists li > a");
	const $solutionItems = $(".js-ft-product .switch-items");

	// remove active
	$solutionTabs.parent("li").removeClass("active");

	// set active
	$navItem.parent("li").addClass("active");

	// Add Params to URL
	const url = new URL(window.location.href);
	url.searchParams.set("tab", selectedTab);
	window.history.pushState(null, null, url);

	// Remove highlighted class in all items
	$solutionItems.find(".switch-item").removeClass("active");

	// Highlight all items based selected selectedTab
	$solutionItems.find(`.item-${selectedTab}`).addClass("active");
}

function updateBannerPosition() {
	let leftPos = window.scrollX + document.querySelector(".banner-hero-image").getBoundingClientRect().left;
	if (window.innerWidth >= 1024) {
		// Apply only on screens wider than 1024px (desktop)
		let leftPos = window.scrollX + document.querySelector(".banner-hero-image").getBoundingClientRect().left;
		$(".product-banner-image")
			.css("left", leftPos + "px")
			.css("width", `calc(100% - ${leftPos}px)`)
			.removeClass("lg:hidden");
	} else {
		// Optionally reset or hide styles for mobile screens
		$(".product-banner-image").css("left", "").css("width", "").addClass("lg:hidden");
	}
}

$(function () {
	// get UrlParams 'tab' and select
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get("tab") !== null) {
		const selectedTab = urlParams.get("tab");
		const $tabItem = $(`.js-ft-product .solution-lists li > a.switch-${selectedTab}`);

		switchContent($tabItem, selectedTab);
	}

	// Highligth Contents
	$(".js-ft-product").on("click", ".solution-lists li > a", function (e) {
		e.preventDefault();

		const $this = $(this);

		let selectedTab = $this.attr("href");
		selectedTab = selectedTab.replace("#", "");

		switchContent($this, selectedTab);
	});

	// Mobile: Accordion
	$(".js-ft-product").on("click", ".collapse-bar", function (e) {
		// scrollTop
		$("html,body").animate({ scrollTop: $(".mobile-accordion .collapsed").offset().top - 140 }, 200);
	});

	// Initial position update
	updateBannerPosition();

	// Listen to the window scroll event
	window.addEventListener("scroll", function () {
		updateBannerPosition(); // Recalculate the position on scroll
	});

	// Optional: Listen to the window resize event as well, in case the layout changes
	window.addEventListener("resize", function () {
		updateBannerPosition(); // Recalculate the position on resize
	});
});
